import React from "react";
import Styles from "../Home/AboutMe.module.css";
import LatestPostHeader from "../Home/LatestPostHeader";
import styles from "../Home/LatestPosts.module.css";
import PROJECTS_LIST from "../BlogPostData/ProjectsList";
import ProjectItem from "../ListItems/Projectitem";

const Projects = () => {
  const blogPost = PROJECTS_LIST.map((post) => (
    <ProjectItem
      key={post.id}
      title={post.title}
      date={post.date}
      image={post.description}
      url={post.link}
    />
  ));
  return (
    <div
      className={Styles.Main}
      style={{ flexDirection: "column", paddingLeft: 0 }}
    >
      <LatestPostHeader demo={""} margin={"marginLeft:0"} title="Projects" />
      <div>
        <section>
          <ul className={styles.grid} style={{ paddingBottom: 200 }}>
            {blogPost}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Projects;
